import { Col, Row, Title } from 'ui';
import { useUser } from 'features/auth';
import { type StatusType, useDexcomDesync, useDexcomSync } from 'features/dexcom';
import { DexcomRow } from './dexcom-row';

const clientId = 'cDVvnes7gOhl87yuKaf6tgRja95LbqfB';

type P = {
  automaticSync?: boolean;
  onFinished: ({ messageText, status }: { messageText: string; status: StatusType }) => void;
};

const DexcomSync = ({ automaticSync, onFinished }: P) => {
  const { isSyncing, syncDexcom } = useDexcomSync(clientId, onFinished);
  const { desyncDexcom, isDesyncing } = useDexcomDesync(onFinished);

  const { railsUserData: viewer } = useUser();

  if (automaticSync && !isSyncing && !viewer.dexcom.synced) {
    syncDexcom();
  }

  return (
    <Row gutter={[0, 'ms']}>
      <Col span={24}>
        <Title level={3}>Dexcom sync</Title>
      </Col>
      <Col span={24}>
        {viewer.dexcom.synced ? (
          <DexcomRow
            button={{
              children: 'Unsync',
              danger: true,
              loading: isDesyncing,
              onClick() {
                desyncDexcom();
              },
              type: 'secondary',
            }}
            title="Dexcom account synced"
          />
        ) : (
          <DexcomRow
            button={{
              children: 'Sync',
              loading: isSyncing,
              onClick() {
                syncDexcom();
              },
              type: 'primary',
            }}
            title="Dexcom account not synced"
          />
        )}
      </Col>
    </Row>
  );
};

export default DexcomSync;
